var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.submitLoading),expression:"submitLoading"}],attrs:{"element-loading-text":"请稍等..."}},[_c('sponsor-process',{ref:"processForm",attrs:{"code":_vm.selectForm.formId,"preview":_vm.selectForm.preview},on:{"submitForm":function($event){return _vm.submitForm()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }